import { render, staticRenderFns } from "./CreatePresentationModal.vue?vue&type=template&id=1901aa70&"
import script from "./CreatePresentationModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePresentationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1633016199/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1901aa70')) {
      api.createRecord('1901aa70', component.options)
    } else {
      api.reload('1901aa70', component.options)
    }
    module.hot.accept("./CreatePresentationModal.vue?vue&type=template&id=1901aa70&", function () {
      api.rerender('1901aa70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreatePresentationModal.vue"
export default component.exports